const GENERICS_TAG_TYPES = {
  GENERICS_IMPROVEMENTS: "GENERICS_IMPROVEMENTS"
};

export const GENERICS_TAGS = Object.values(GENERICS_TAG_TYPES);
export default GENERICS_TAG_TYPES;
